export const createTableListaProcesuHarm = () => {
    return [
        {
            accessorKey: 'id',
            header: 'ID',
            filterFn: 'includesString',
        },
        {
            accessorKey: 'status',
            header: 'Status',
            filterFn: 'includesString',
        },
        {
            accessorKey: 'data_zdarzenia',
            header: 'Data zdarzenia',
            filterFn: 'includesString',
        },
        {
            accessorKey: 'wersja',
            header: 'Wersja',
            filterFn: 'includesString',
        },
    ]
}
